<template>
  <b-container fluid>
    <b-breadcrumb>
      <b-breadcrumb-item to="/dashboard">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true" />&nbsp;Dashboard
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/complaints-dashboard" v-if="employeeuserOnly == 1">Complaints</b-breadcrumb-item>
      <b-breadcrumb-item active>
        Complaint Detail
        <!-- <span v-if="complaintDetail.is_anonymous == 0">
          <strong>Complaint by :</strong>
          {{complaintDetail.requested_by_first_name + ' ' + complaintDetail.requested_by_last_name}}
        </span>-->
      </b-breadcrumb-item>
    </b-breadcrumb>
    <b-row>
      <b-col cols="3">
        <div style="height: calc(100vh - 170px); overflow-y: auto;">
          <b-overlay :show="isLoading" rounded="sm">
            <b-card>
              <template v-slot:header>
                <h6 class="text-left">Details</h6>
              </template>
              <b-card-body class="text-left">
                <p>
                  <strong>Date of Complatint:</strong>
                  <br />
                  {{complaintDetail.due_date ? formatDate(complaintDetail.due_date) : ''}}
                </p>
                <p>
                  <strong>Complaint Type:</strong>
                  <br />
                  {{complaintDetail.type ? complaintDetail.type : ''}}
                </p>
                <p>
                  <strong>Status :</strong>&nbsp;
                  <b-badge v-if="complaintDetail.status == 1" variant="info">OPEN</b-badge>
                  <b-badge v-else-if="complaintDetail.status == 2" variant="success">ClOSED</b-badge>
                  <b-badge v-else-if="complaintDetail.status == 3" variant="warning">ON-HOLD</b-badge>
                </p>
                <p v-if="complaintDetail.is_anonymous == 0">
                  <strong>Complaint by :</strong>
                  <br />
                  {{complaintDetail.requested_by_first_name + ' ' + complaintDetail.requested_by_last_name}}
                </p>
                <p v-if="complaintDetail.status == 2">
                  <strong>Closed On:</strong>
                  <br />
                  {{complaintDetail.date_completed ? formatDate(complaintDetail.date_completed) : ''}}
                </p>
              </b-card-body>
            </b-card>
          </b-overlay>
          <b-card class="mt-3" v-if="employeeuserOnly == 1 && complaintDetail.status == 1">
            <template v-slot:header>
              <h6 class="text-left">Actions</h6>
            </template>
            <b-card-body>
              <b-button @click="closeComplaintApiCall" class="m-1" variant="outline-danger">Close</b-button>
            </b-card-body>
          </b-card>
        </div>
      </b-col>
      <b-col cols="9">
        <div style="height: calc(100vh - 120px); overflow-y: auto;">
          <b-card no-body>
            <b-tabs card>
              <b-tab
                title="Complaint"
                active
                class="text-left"
                style="height: calc(100vh - 230px); overflow: hidden auto;"
              >
                <div class="mt-3" v-if="!isLoadingFormData">
                  <EmployeeComplaintForm :complaintViewPage="true" :formData="formData" />
                </div>
              </b-tab>
              <b-tab
                title="Description"
                class="text-left"
                style="height: calc(100vh - 230px); overflow: hidden auto;"
              >
                <b-card v-if="complaintDetail.meta_data == null">
                  <b-form-group class="mb-2">
                    <b-row>
                      <b-col cols="3">
                        <label class="text-left">
                          Title:
                          <span class="required-span">*</span>
                        </label>
                      </b-col>
                      <b-col cols="9">
                        <b-form-input
                          size="sm"
                          v-model="$v.form.title.$model"
                          :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-form-group class="mb-2">
                    <b-row>
                      <b-col cols="3">
                        <label class="text-left">
                          Investigation Details:
                          <span class="required-span">*</span>
                        </label>
                      </b-col>
                      <b-col cols="9">
                        <b-form-input
                          size="sm"
                          v-model="$v.form.investigationDetails.$model"
                          :state="$v.form.investigationDetails.$dirty ? !$v.form.investigationDetails.$error : null"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-form-group class="mb-2">
                    <b-row>
                      <b-col cols="3">
                        <label class="text-left">
                          Complaint Justified:
                          <span class="required-span">*</span>
                        </label>
                      </b-col>
                      <b-col cols="9">
                        <b-form-radio-group
                          v-model="$v.form.complaintJustified.$model"
                          :state="$v.form.complaintJustified.$dirty ? !$v.form.complaintJustified.$error : null"
                        >
                          <b-form-radio value="Yes">Yes</b-form-radio>
                          <b-form-radio value="No">No</b-form-radio>
                        </b-form-radio-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                  <b-row>
                    <b-col cols="12" class="text-right">
                      <b-btn
                        variant="outline-success"
                        size="sm"
                        @click="checkDiscriptionValidation"
                      >Save</b-btn>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card v-else>
                  <p>
                    <strong>Title :</strong>
                    {{complaintDetail.meta_data ? JSON.parse(complaintDetail.meta_data).title : ''}}
                  </p>
                  <p>
                    <strong>Investigation Details :</strong>
                    {{complaintDetail.meta_data ? JSON.parse(complaintDetail.meta_data).investigationDetails : ''}}
                  </p>
                  <p>
                    <strong>Complaint Justified :</strong>
                    {{complaintDetail.meta_data ? JSON.parse(complaintDetail.meta_data).complaintJustified : ''}}
                  </p>
                </b-card>
              </b-tab>
              <!-- <b-tab title="Tasks">
                <b-row>
                  <b-col cols="12">
                    <b-table-simple borderless>
                      <b-thead>
                        <b-tr>
                          <b-th>Title</b-th>
                          <b-th>Date</b-th>
                          <b-th>Status</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr>
                          <b-td>Karan</b-td>
                          <b-td>22/06/2020</b-td>
                          <b-td>
                            <b-badge variant="success">Complete</b-badge>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>Nazmul</b-td>
                          <b-td></b-td>
                          <b-td>
                            <b-badge variant="warning">Pending</b-badge>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>Gaurav</b-td>
                          <b-td>19/06/2020</b-td>
                          <b-td>
                            <b-badge variant="danger">Not Approved</b-badge>
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </b-col>
                </b-row>
              </b-tab>-->
              <b-tab title="Action">
                <b-modal
                  :title="'Add Actions'"
                  v-model="showAddActionsModal"
                  size="md"
                  scrollable
                  no-close-on-backdrop
                  no-close-on-esc
                  hide-header-close
                >
                  <div>
                    <div class="text-center" v-if="!submiting && !responseSuccess">
                      <b-form-group style="margin: 1rem;">
                        <b-form-input
                          v-model="complaintsActionValue"
                          placeholder="Add Action"
                          size="sm"
                        ></b-form-input>
                      </b-form-group>
                    </div>
                    <div v-else-if="submiting && !responseSuccess">
                      <p>Your Action is being adding......</p>
                      <b-spinner type="grow" label="Loading..."></b-spinner>
                    </div>
                    <div v-else>
                      <p class="my-2 text-center">
                        Your Action has been Added successfully.
                        <br />
                      </p>
                    </div>
                  </div>
                  <template v-slot:modal-footer>
                    <b-button
                      v-if="!submiting"
                      @click="closeComplaintActionsModal"
                      variant="outline-danger"
                    >Close</b-button>
                    <b-button
                      v-if="!submiting && !responseSuccess"
                      @click="addComplaintActions"
                      variant="outline-success"
                    >Add</b-button>
                  </template>
                </b-modal>
                <b-overlay :show="isLoadingComplaintsActions" rounded="sm">
                  <div style="height: calc(100vh - 235px); overflow-y: auto;">
                    <b-table-simple small responsive="sm">
                      <b-thead>
                        <b-tr>
                          <b-th>Actions</b-th>
                          <b-th></b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="(tasks,index) in tasksData" :key="index">
                          <b-td>{{tasks.action}}</b-td>
                          <b-td>
                            <font-awesome-icon
                              v-b-tooltip.hover
                              title="Delete Task"
                              icon="trash"
                              :class="'ml-2 text-danger'"
                              @click="deleteTask(tasks)"
                            />
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <div class="mb-2">
                      <b-button
                        v-if="employeeuserOnly == 1"
                        :disabled="complaintDetail.status == 2"
                        size="sm"
                        variant="outline-warning"
                        @click="showAddActionsModal = !showAddActionsModal"
                      >Add Action</b-button>
                    </div>
                  </div>
                </b-overlay>
              </b-tab>
              <b-tab title="Approvals" class="text-left">
                <b-modal
                  title="Add Approvals"
                  v-model="addApprovalModal"
                  size="md"
                  no-close-on-backdrop
                  no-close-on-esc
                  hide-header-close
                >
                  <div>
                    <b-form-group label-size="Select Approvals">
                      <v-select
                        :class="'form-control-small'"
                        label="text"
                        v-model="selectedApprovels"
                        :options="employeeListOption"
                        :searchable="true"
                        :clearable="true"
                        :multiple="true"
                      ></v-select>
                    </b-form-group>
                  </div>
                  <template v-slot:modal-footer>
                    <b-button @click="closeModalAddApprovalModal" variant="outline-danger">Close</b-button>
                    <b-button @click="addApprovalApiCall" variant="outline-success">Add</b-button>
                  </template>
                </b-modal>
                <b-card class="mt-3" no-body>
                  <b-card-title style="padding: 15px;">
                    <b-row>
                      <b-col cols="4">Approver</b-col>
                      <b-col cols="8">
                        <div class="text-right">
                          <b-btn
                            variant="outline-info"
                            size="sm"
                            :disabled="complaintDetail.status == 2"
                            @click="opneAddApprovalModal"
                          >
                            <font-awesome-icon icon="plus" />
                          </b-btn>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card-title>
                  <b-card-body>
                    <b-overlay :show="isLoadingApprovalsList" rounded="sm">
                      <b-table-simple borderless small>
                        <b-thead>
                          <b-tr>
                            <b-th>Approver</b-th>
                            <b-th>Status</b-th>
                          </b-tr>
                        </b-thead>
                        <b-tbody>
                          <b-tr
                            v-for="(approver, approverIndex) in complaintApproversList"
                            :key="approverIndex"
                          >
                            <b-td>
                              <b-avatar
                                v-if="approver.first_name && approver.last_name && approver.profile_img_url == null"
                                variant="success"
                                v-b-tooltip.hover.bottom="approver.first_name+' '+approver.last_name"
                              >{{getApproverName(approver)}}</b-avatar>
                              <b-avatar
                                v-else-if="approver.profile_img_url"
                                variant="info"
                                v-b-tooltip.hover.bottom="approver.first_name+' '+approver.last_name"
                                :src="approver.profile_img_url"
                              ></b-avatar>
                            </b-td>
                            <b-td>
                              <b-badge v-if="approver.status == 1" variant="info">OPEN</b-badge>
                              <b-badge v-else-if="approver.status == 2" variant="success">ClOSED</b-badge>
                              <b-badge v-else-if="approver.status == 3" variant="warning">ON-HOLD</b-badge>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-overlay>
                  </b-card-body>
                </b-card>
              </b-tab>
              <b-tab title="File Upload" :lazy="fileUploadTabLazy">
                <b-overlay :show="isLoadingComplaintsFiles" rounded="sm">
                  <div style="height: calc(100vh - 235px);overflow-y: auto;overflow-x: hidden;">
                    <b-navbar toggleable="lg" type="dark" variant="light">
                      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                      <b-navbar-brand href="#" class="text-dark">
                        <strong>Approval Files</strong>
                      </b-navbar-brand>

                      <b-collapse id="nav-collapse" is-nav>
                        <!-- Right aligned nav items -->
                        <b-navbar-nav class="ml-auto">
                          <b-nav-form>
                            <b-button
                              v-if="employeeuserOnly == 1"
                              @click="showUploadModal = !showUploadModal"
                              :disabled="complaintDetail.status == 2"
                              class="my-2 my-sm-0 mr-2"
                              variant="outline-primary"
                              size="sm"
                            >
                              <font-awesome-icon icon="plus" />
                            </b-button>
                            <b-button
                              variant="outline-info"
                              size="sm"
                              class="mr-2"
                              @click="reloadTableFilesTable"
                            >
                              <font-awesome-icon icon="sync" />
                            </b-button>
                          </b-nav-form>
                        </b-navbar-nav>
                      </b-collapse>
                    </b-navbar>
                    <b-table
                      bordered
                      class="mx-1"
                      sticky-header="calc(100vh - 220px)"
                      ref="table"
                      id="my-complaints-files-table"
                      :busy.sync="isLoadingComplaintsFiles"
                      :fields="filesTableFields"
                      :items="getComplaintsFiles"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                    >
                      <template v-slot:cell(created_at)="data">
                        <p>{{ createdAtDate(data.item.created_at) }}</p>
                      </template>
                      <template
                        v-slot:cell(contact_name)="data"
                      >{{data.item.first_name + ' ' + data.item.last_name}}</template>
                      <template v-slot:cell(actions)="data">
                        <b-btn size="sm" variant="outline-danger" @click="downloadFile(data)">
                          <font-awesome-icon icon="download" />
                        </b-btn>
                      </template>
                    </b-table>
                    <p class="mt-3">Current Page: {{ perPage }} rows</p>
                    <b-row>
                      <b-col cols="2">
                        <b-form-select
                          v-model="perPage"
                          id="perPageSelect"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select>
                      </b-col>
                      <b-col>
                        <b-pagination
                          class="float-right"
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                          first-text="First"
                          prev-text="Prev"
                          next-text="Next"
                          last-text="Last"
                          aria-controls="my-complaints-files-table"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                  </div>
                </b-overlay>
                <b-modal
                  title="File Upload"
                  v-model="showUploadModal"
                  size="lg"
                  scrollable
                  no-close-on-backdrop
                  no-close-on-esc
                  hide-header-close
                >
                  <div>
                    <div class="text-center" v-if="!submiting && !responseSuccess">
                      <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        v-on:vdropzone-sending="sendingEvent"
                        @vdropzone-success="vsuccess"
                        :options="dropzoneOptions"
                        :useCustomSlot="true"
                        class="m-5 p-3"
                        style="border:dashed 1px"
                      >
                        <div class="dropzone-custom-content">
                          <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                          <div class="subtitle">...or click to select a file from your computer</div>
                        </div>
                      </vue-dropzone>
                      <b-form-group label-cols-sm="4" label-cols-lg="3" label="Display Name">
                        <b-form-input type="text" v-model="uploadFileDisplayName" size="sm" />
                      </b-form-group>
                    </div>
                    <div v-else-if="submiting && !responseSuccess">
                      <p>Your File is being Uploading......</p>
                      <b-spinner type="grow" label="Loading..."></b-spinner>
                    </div>
                    <div v-else>
                      <p class="my-2 text-center">
                        Your File has been uploaded successfully.
                        <br />
                      </p>
                    </div>
                  </div>
                  <template v-slot:modal-footer>
                    <div class="float-right">
                      <b-button
                        class="mr-3"
                        variant="outline-danger"
                        v-if="!uploading"
                        @click="resetUploadModal"
                      >Cancel</b-button>
                      <b-button
                        variant="outline-success"
                        v-if="!uploading && !responseSuccess"
                        @click="uploadFileApiCall"
                      >Upload</b-button>
                    </div>
                  </template>
                </b-modal>
              </b-tab>
              <b-tab title="ACTIVITY" :title-link-class="'activity-tab'">
                <b-card class="mt-2">
                  <template v-slot:header>
                    <b-row>
                      <b-col cols="6">
                        <h6 class="text-left">Activity</h6>
                      </b-col>
                      <b-col cols="6">
                        <div class="float-right">
                          <b-button
                            variant="outline-info"
                            size="sm"
                            class="mr-2"
                            @click="getActivityLog"
                          >
                            <font-awesome-icon icon="sync" />
                          </b-button>
                        </div>
                      </b-col>
                    </b-row>
                  </template>
                  <b-card-body>
                    <div id="container" class="scrollFlow" style>
                      <b-row>
                        <b-col cols="12">
                          <b-overlay :show="isLoadingActivityLog" rounded="sm">
                            <div>
                              <ul class="timeline" style="margin-bottom: 50px;">
                                <li v-for="(logData,index) in activityLogData" :key="index">
                                  <p class="text-muted">{{ formatDate(logData.created_at) }}</p>
                                  <p>{{logData.notes}}</p>
                                </li>
                              </ul>
                            </div>
                          </b-overlay>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-body>
                </b-card>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../../components/Dropzone/VueDropzone";
import moment from "moment";
import "moment/locale/es";
// import draggable from "vuedraggable";
import axios from "axios";
import config from "../../configs/config";
import { Helper } from "../../helpers";
import EmployeeComplaintForm from "./employeeComplaintForm.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ViewComplaints",
  mixins: [validationMixin],
  components: {
    VueDropzone,
    EmployeeComplaintForm,
  },
  data() {
    return {
      employeeuserOnly: null,
      taskInput: null,
      tasksData: [],
      notesInput: null,
      notesData: [],
      dropzoneOptions: {
        url:
          process.env.VUE_APP_API_URL +
          "api/v1/complaints/files/upload/" +
          this.$route.params.complaintId,
        thumbnailWidth: 150,
        maxFilesize: 25,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      },
      dragging: false,
      setInputArray: [],
      checkValue: null,
      categoryIndex: null,
      invalidValue: null,
      validInputField: false,
      isLoading: false,
      isLoadingFormData: true,
      complaintDetail: {},
      showAddNotesModal: false,
      isLoadingComplaintsFiles: false,
      fileUploadTabLazy: true,
      showUploadModal: false,
      isLoadingComments: false,
      submiting: false,
      responseSuccess: false,
      uploading: false,
      uploadFileDisplayName: null,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      filesTableFields: [
        { key: "created_at", label: "Uploaded At", sortable: true },
        { key: "contact_name", label: "Employee", sortable: true },
        { key: "display_name", label: "Display Name", sortable: true },
        { key: "actions", label: "Actions", sortable: false },
      ],
      isLoadingComplaintsActions: false,
      complaintsActionValue: null,
      showAddActionsModal: false,
      formData: [],
      addApprovalModal: false,
      selectedApprovels: [],
      employeeListOption: [],
      complaintApproversList: [],
      isLoadingApprovalsList: false,
      activityLogSortBy: "id",
      activityLogSortDesc: true,
      isLoadingActivityLog: false,
      activityLogData: [],
      form: {
        title: null,
        investigationDetails: null,
        complaintJustified: null,
      },
      createdDate: null,
    };
  },
  validations: {
    form: {
      title: { required },
      investigationDetails: { required },
      complaintJustified: { required },
    },
  },
  computed: {
    rows() {
      return this.totalRows;
    },
  },
  mounted() {
    this.employeeuserOnly = this.$route.params.userType;
    this.getComplaintsActionData();
    this.getComplaintsDetail();
    this.getComplaintNotesList();
    this.getApprovalListApi();
    this.getActivityLog();
  },
  methods: {
    resetDiscriptionForm() {
      this.form = {
        title: null,
        investigationDetails: null,
        complaintJustified: null,
      };
    },
    checkDiscriptionValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else {
        this.submitDiscriptionApiCall();
      }
    },
    async submitDiscriptionApiCall() {
      let formData = {
        meta_data: {
          title: this.form.title,
          investigationDetails: this.form.investigationDetails,
          complaintJustified: this.form.complaintJustified,
        },
      };
      let response = await HTTP(
        "post",
        "api/v1/complaints/add/discription/" + this.$route.params.complaintId,
        formData
      );
      try {
        if (response && response.data && response.data.success == 1) {
          this.getComplaintsDetail();
          this.resetDiscriptionForm();
          this.makeToster("success", "Discription successfully Added");
        }
      } catch (err) {
        return [err];
      }
    },
    getApproverName(data) {
      let firstName = data.first_name.toUpperCase();
      let lastName = data.last_name.toUpperCase();
      let name = firstName.charAt(0) + lastName.charAt(0);

      return name;
    },
    opneAddApprovalModal() {
      this.addApprovalModal = true;
      this.getEmployeeList();
    },
    async getEmployeeList() {
      this.employeeListOption = [];
      let formData = {
        user_types: [1, 2],
      };
      this.isLoading = true;
      try {
        let result = await HTTP(
          "post",
          "api/v1/employees/get-employee-options",
          formData
        );
        if (result && result.data) {
          result.data.employeeList.map((options) => {
            this.employeeListOption.push({
              id: options.id,
              email: options.email,
              text: options.first_name + " " + options.last_name,
            });
          });
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    closeModalAddApprovalModal() {
      this.addApprovalModal = false;
      this.selectedApprovels = [];
      this.employeeListOption = [];
    },
    async getApprovalListApi() {
      this.complaintApproversList = [];
      this.isLoadingApprovalsList = true;
      let response = await HTTP(
        "get",
        "api/v1/complaints/approvers/" + this.$route.params.complaintId,
        null
      );
      try {
        this.complaintApproversList = response.data.complaint_approvers;
        this.isLoadingApprovalsList = false;
      } catch (err) {
        this.isLoadingApprovalsList = false;
        this.fileUploadTabLazy = false;
        return [err];
      }
    },
    async addApprovalApiCall() {
      let formData = {
        complaint_type_id: this.complaintDetail.complaint_type_id,
        approvers: this.selectedApprovels,
        user_id: localStorage.getItem("userId"),
      };
      this.isLoadingApprovalsList = true;
      let response = await HTTP(
        "post",
        "api/v1/complaints/assign/approvers/" + this.$route.params.complaintId,
        formData
      );
      try {
        if (response && response.data && response.data.status == 1) {
          this.makeToster("success", "Approvels successfully Added");
        }
        this.isLoadingApprovalsList = false;
      } catch (err) {
        this.isLoadingApprovalsList = false;
        return [err];
      }
    },
    makeToster(tosterVarient, tosterMsg) {
      this.closeModalAddApprovalModal();
      Helper.makeToast(this.$bvToast, tosterVarient, tosterMsg);
    },
    createdAtDate(value) {
      moment.locale("en");
      return moment(value).format("DD/MM/YYYY");
    },
    reloadTableFilesTable() {
      this.$root.$emit("bv::refresh::table", "my-complaints-files-table");
    },
    async getComplaintsFiles() {
      let formData = {
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoadingComplaintsFiles = true;
      let response = await HTTP(
        "post",
        "api/v1/complaints/get/files/" + this.$route.params.complaintId,
        formData
      );
      try {
        this.totalRows = response.data.total;
        this.isLoadingComplaintsFiles = false;
        this.fileUploadTabLazy = false;
        return response.data.data;
      } catch (err) {
        this.isLoadingComplaintsFiles = false;
        this.fileUploadTabLazy = false;
        return [err];
      } finally {
        this.isLoadingComplaintsFiles = false;
        this.fileUploadTabLazy = false;
      }
    },
    async getComplaintsDetail() {
      this.complaintDetail = {};
      this.formData = [];
      let complaintId = this.$route.params.complaintId;
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "api/v1/complaints/detail/" + complaintId, {
        Authorization: token,
      });
      return result
        .then((response) => {
          this.complaintDetail = response.data;
          this.createdDate = response.data.created_at;
          this.formData = JSON.parse(response.data.form_data);
          this.isLoading = false;
          this.isLoadingFormData = false;
        })
        .catch((error) => {
          this.isLoading = false;
          return [error];
        });
    },
    setArrayValue(data, index) {
      this.checkValue = data;
      this.categoryIndex = index;
      this.setInputArray.push(data);
    },
    async getComplaintsActionData() {
      this.tasksData = [];
      this.isLoadingComplaintsActions = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/complaints/get/complaint/actions/" +
            this.$route.params.complaintId,
          null
        );
        this.tasksData = result.data.complaintActions;
        this.isLoadingComplaintsActions = false;
      } catch (error) {
        this.isLoadingComplaintsActions = false;
      }
    },
    async addComplaintActions() {
      let formData = {
        action: this.complaintsActionValue,
        user_id: localStorage.getItem("userId"),
      };
      try {
        this.submiting = true;
        this.isLoadingComplaintsActions = true;
        let result = await HTTP(
          "post",
          "api/v1/complaints/add/complaint/actions/" +
            this.$route.params.complaintId,
          formData
        );
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComplaintsActions = false;
        this.getComplaintsActionData();
        if (result.data.status == 1) {
          this.closeComplaintActionsModal();
          Helper.makeToast(
            this.$bvToast,
            "success",
            "Action Has Been successfully Added"
          );
        }
      } catch (err) {
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComplaintsActions = false;
        return [err];
      }
    },
    closeComplaintActionsModal() {
      this.isLoadingComplaintsActions = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showAddActionsModal = false;
      this.complaintsActionValue = null;
    },
    async closeComplaintApiCall() {
      let formData = {
        created_at: this.createdDate,
        complaint_id: this.$route.params.complaintId,
        status: 2,
        user_id: localStorage.getItem("userId"),
      };
      try {
        let result = await HTTP(
          "post",
          "api/v1/complaints/update/status",
          formData
        );
        this.getComplaintsDetail();
        if (result.data.status == 1) {
          Helper.makeToast(
            this.$bvToast,
            "success",
            "Complaint has been closed successfully."
          );
        }
      } catch (err) {
        return [err];
      }
    },
    async getActivityLog() {
      let formData = {
        activity_log_model_id: this.$route.params.complaintId,
        activity_log_type: "Complaints",
        user_id: localStorage.getItem("userId"),
        sort:
          this.activityLogSortBy +
          "|" +
          (this.activityLogSortDesc == true ? "desc" : "asc"),
      };
      this.isLoadingActivityLog = true;
      let response = await HTTP(
        "post",
        "api/v1/activitylog/get/with/type",
        formData
      );
      try {
        this.activityLogData = response.data.data;
        this.isLoadingActivityLog = false;
      } catch (err) {
        this.isLoadingActivityLog = false;
        return [err];
      } finally {
        this.scrollToEnd();
        this.isLoadingActivityLog = false;
      }
    },
    scrollToEnd() {
      var container = this.$el.querySelector("#container");
      container.scrollTop = container.scrollHeight + 120;
    },
    formatDate(value) {
      if (value) {
        moment.locale("en");
        return moment(String(value)).format("DD MMMM, YYYY");
      }
    },
    async deleteTask(value) {
      let formData = {
        complaints_id: this.$route.params.complaintId,
        user_id: localStorage.getItem("userId"),
      };
      this.isLoadingComplaintsActions = true;
      try {
        await HTTP(
          "post",
          "api/v1/complaints/delete/complaint/actions/" + value.id,
          formData
        );
        this.isLoadingComplaintsActions = false;
        this.getComplaintsActionData();
      } catch (error) {
        this.isLoadingComplaintsActions = false;
      }
    },
    dateFormat(value) {
      if (value) {
        moment.locale("en");
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    onShowNoteModal() {
      this.showAddNotesModal = true;
    },
    async addComplaintComments() {
      let formData = {
        status: this.notesStatus,
        note: this.notesInput,
        user_id: localStorage.getItem("userId"),
        employee_id: localStorage.getItem("employeeId"),
      };
      try {
        this.submiting = true;
        this.isLoadingComments = true;
        let result = await HTTP(
          "post",
          "api/v1/complaints/add/complaint/notes/" +
            this.$route.params.complaintId,
          formData
        );
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComments = false;
        var data = {
          created_at: new Date(),
          note: this.notesInput,
        };
        this.notesData.push(data);
        this.notesInput = null;
        if (result.data.status == 1) {
          this.closeModal();
          Helper.makeToast(
            this.$bvToast,
            "success",
            "Note Has Been successfully Added"
          );
        }
      } catch (err) {
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComments = false;
        return [err];
      }
    },
    closeModal() {
      this.isLoadingComments = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showAddNotesModal = false;
      this.notesInput = null;
      // this.invalidApproveNotes = null;
      this.notesStatus = 0;
    },
    async getComplaintNotesList() {
      this.notesData = [];
      this.isLoadingComments = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/complaints/get/complaint/notes/" +
            this.$route.params.complaintId,
          null
        );
        this.notesData = result.data.complaintNotes;
        this.isLoadingComments = false;
      } catch (error) {
        this.isLoadingComments = false;
      }
    },
    uploadFileApiCall() {
      if (this.$refs.myVueDropzone.getQueuedFiles().length > 0) {
        this.uploading = true;
        this.$refs.myVueDropzone.processQueue();
      }
    },
    vsuccess() {
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      this.$bvToast.toast(
        "Your file has been successfully uploaded and is now processed",
        {
          title: "File Upload is complete",
          noAutoHide: false,
          appendToast: true,
        }
      );
      this.$refs.myVueDropzone.removeAllFiles();
      this.reloadTableFilesTable();
    },
    sendingEvent(file, xhr, formData) {
      formData.append("employee_id", localStorage.getItem("employeeId"));
      formData.append("displayName", this.uploadFileDisplayName);
      formData.append("user_id", localStorage.getItem("userId"));
    },
    resetUploadModal() {
      this.isLoadingComplaintsFiles = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showUploadModal = false;
      // this.getApprovalActivityLog();
    },
    async downloadFile(data) {
      let titleForm = data.item.filename;
      axios({
        url: config.API_URL + "api/v1/complaints/file/download/" + data.item.id,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      })
        .then((response) => {
          if (window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([response.data]);
            // IE11
            window.navigator.msSaveOrOpenBlob(blob, titleForm);
            Helper.makeToast(
              this.$bvToast,
              "success",
              "File has been download successfully"
            );
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", titleForm); //or any other extension
            document.body.appendChild(link);
            link.click();
            if (response) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                "File has been download successfully"
              );
            }
          }
        })
        .catch((error) => {
          Helper.makeToast(this.$bvToast, "danger", "Unable to download file.");
          return [error];
        });
    },
  },
};
</script>
<style>
.activity-tab {
  padding-left: 0;
}
</style>
<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
.body-card {
  padding: 0;
}
</style>